/*
  ML013 - "Bekijk per categorie" homepage carousel (A/B variation).

  The track is a native horizontal scroller with CSS scroll-snap, so swipe, trackpad,
  scroll wheel and keyboard focus all move it without any JavaScript. This file only
  reads that scroll position and reflects it in two places:

    1. the desktop arrows, which scroll by one viewport of the track and disable at each end;
    2. the mobile progress bar, whose thumb is sized like a scrollbar thumb (visible
       fraction of the track) and offset by how far through the track we are.

  Sections are initialised individually so `shopify:section:load` can re-run one of them
  after a theme editor change.
*/

(function () {
  if (window.__ml013CategoryCarousel) {
    return;
  }

  window.__ml013CategoryCarousel = true;

  function update(state) {
    var track = state.track;
    var max = track.scrollWidth - track.clientWidth;
    var left = track.scrollLeft;
    var ratio = max > 1 ? left / max : 0;

    if (ratio < 0) {
      ratio = 0;
    }
    if (ratio > 1) {
      ratio = 1;
    }

    if (state.prev) {
      state.prev.disabled = max <= 1 || left <= 1;
    }
    if (state.next) {
      state.next.disabled = max <= 1 || left >= max - 1;
    }

    if (state.progress && state.thumb) {
      var widthPercent = track.scrollWidth ? (track.clientWidth / track.scrollWidth) * 100 : 100;

      if (widthPercent > 100) {
        widthPercent = 100;
      }

      state.thumb.style.width = widthPercent + '%';
      state.thumb.style.marginLeft = ratio * (100 - widthPercent) + '%';
      state.progress.setAttribute('aria-valuenow', String(Math.round(ratio * 100)));
    }
  }

  function schedule(state) {
    if (state.pending) {
      return;
    }

    state.pending = true;

    requestAnimationFrame(function () {
      state.pending = false;
      update(state);
    });
  }

  function init(root) {
    if (root.__ml013) {
      return;
    }

    var track = root.querySelector('[data-ml013-track]');

    if (!track) {
      return;
    }

    var state = {
      track: track,
      prev: root.querySelector('[data-ml013-prev]'),
      next: root.querySelector('[data-ml013-next]'),
      progress: root.querySelector('[data-ml013-progress]'),
      thumb: root.querySelector('[data-ml013-progress-thumb]'),
      pending: false
    };

    root.__ml013 = state;

    function step(direction) {
      // The CSS `scroll-behavior` rule does not apply to an explicit `behavior` option,
      // so the reduced-motion preference has to be read here too.
      var reduced =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      track.scrollBy({
        left: direction * track.clientWidth,
        behavior: reduced ? 'auto' : 'smooth'
      });
    }

    if (state.prev) {
      state.prev.addEventListener('click', function () {
        step(-1);
      });
    }

    if (state.next) {
      state.next.addEventListener('click', function () {
        step(1);
      });
    }

    track.addEventListener(
      'scroll',
      function () {
        schedule(state);
      },
      { passive: true }
    );

    window.addEventListener('resize', function () {
      schedule(state);
    });

    update(state);
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-ml013]');

    for (var i = 0; i < roots.length; i++) {
      init(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
